/**
 * Shared string filter matching logic for all operators.
 * Extracted here to break the circular dependency between filter.tsx and incomingOrdersUtils.ts.
 */
export function matchesStringFilter(
  value: string,
  operator: string,
  filterValue?: string | null,
  filterValues?: string[] | null,
): boolean {
  const valueLower = value.toLowerCase()
  const singleValue = filterValue?.toLowerCase() ?? ""
  const multipleValues = filterValues?.map((x) => x.toLowerCase()) ?? []

  switch (operator) {
    case "=":
    case "equals":
    case "include":
      return valueLower === singleValue
    case "!=":
    case "exclude":
      return valueLower !== singleValue
    case "startsWith":
      return valueLower.startsWith(singleValue)
    case "endsWith":
      return valueLower.endsWith(singleValue)
    case "contains":
      return valueLower.includes(singleValue)
    case "doesNotContain":
      return !valueLower.includes(singleValue)
    case "oneOf":
      return multipleValues.includes(valueLower)
    case "notOneOf":
      return !multipleValues.includes(valueLower)
    default:
      return true
  }
}
